// src/Spinner.js
import React from 'react';
import './App.css'; 

function Spinner() {
    return (
        <div className="spinner-container">
            <div className="spinner"></div>
        </div>
    );
}

export default Spinner;
